import React from 'react';
import {
  Alert,
  Radio,
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Panel,
  Tabs,
  Tab,
  InputGroup,
  Nav,
  NavItem,
  Row,
  Col
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { injectIntl } from 'react-intl';
import { TOOLS_DATA, SECTIONS_DATA } from '../igroadmap_components/constants';
import { Switch, Route, Redirect } from 'react-router-dom';
import BmcBoardWrapper from '../common_components/wrappers/BmcBoardWrapper';
import { STARTUP_SECTIONS } from '../igmvp_components/models/constants';
import IgBusinessWrapper from '../common_components/wrappers/IgBusinessWrapper';
import IgPanel from '../common_components/IgPanel';
import { TOOLS } from '../igauthorization_components/constants';
import { BOARD_TYPES } from '../igbusiness_components/constants';
import { RenderInstructional } from '../instructional_feed_components/RenderInstructional';

const BusinessSections = {
  BMC:       TOOLS_DATA.IGCUSTOMERS,
  TOC:       TOOLS_DATA.TOC,
  IGBUSINESS:TOOLS_DATA.IGBUSINESS
};

class CustomerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trainVisible: sessionStorage.getItem('trainVisible') === 'true'
    };
    this.tocWrapper    = null;
    this.rootContainer = null;
  }

  showMainTrain = () => {
    if (!this.tocWrapper) {
      return requestAnimationFrame(this.showMainTrain);
    }

    const anchor = document.getElementById('main-train-anchor');
    if (!anchor) return;

    sessionStorage.setItem('trainVisible', 'true');

    if (anchor.parentNode !== this.tocWrapper) {
      this.tocWrapper.appendChild(anchor);
    }

    anchor.removeAttribute('hidden');
    anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    anchor.focus?.();

    this.setState({ trainVisible: true });
  };

  hideMainTrain = () => {
    const anchor = document.getElementById('main-train-anchor');
    if (!anchor) return;

    if (this.rootContainer && anchor.parentNode !== this.rootContainer) {
      this.rootContainer.appendChild(anchor);
    }

    anchor.setAttribute('hidden', '');
    sessionStorage.removeItem('trainVisible');
    this.setState({ trainVisible: false });
  };

  componentDidMount() {
    const { location } = this.props;
    const isToc = location.pathname.includes(
      `/customers/${BusinessSections.TOC.name}`
    );
    if (isToc || sessionStorage.getItem('trainVisible') === 'true') {
      this.showMainTrain();
    }
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.location.pathname;
    const curr = this.props.location.pathname;
    const wasToc = prev.includes(
      `/customers/${BusinessSections.TOC.name}`
    );
    const isToc = curr.includes(
      `/customers/${BusinessSections.TOC.name}`
    );

    if (isToc && !wasToc) this.showMainTrain();
    if (!isToc && wasToc) this.hideMainTrain();
  }

  renderNavItem(name, iconClassName) {
    const { intl, location } = this.props;
    const width = `${100 / SECTIONS_DATA.get('CUSTOMERS').tools.length}%`;

    let active = location.pathname.includes(`/customers/${name}`);
    if (name === BusinessSections.BMC.name) {
      active =
        active || location.pathname.includes('/bmc_boards/');
    }

    return (
      <NavItem
        key={name}
        title={intl.formatMessage({ id: `${name}_help` })}
        active={active}
        style={{ width }}
        onClick={() => {
          name === BusinessSections.TOC.name
            ? this.showMainTrain()
            : this.hideMainTrain();
        }}
      >
        <LinkContainer to={`/${intl.locale}/customers/${name}`}>
          <span className="round-tab">
            <h5 className="text-icon">
              {intl.formatMessage({ id: name })}
            </h5>
            <i className={iconClassName} />
          </span>
        </LinkContainer>
      </NavItem>
    );
  }

  render() {
    const { intl, currentBmcId, location } = this.props;
    const width = `${100 - 100 / Object.keys(BusinessSections).length}%`;
    const modal = new URLSearchParams(location.search).get('modal');
    const currentPath = location.pathname;
    const isValidPath = Object.values(BusinessSections).some(sec =>
      currentPath.includes(`/customers/${sec.name}`)
    );

    return (
      <div
        className="container customer"
        ref={el => (this.rootContainer = el)}
      >
        <Tab.Container id="tabsss">
          <Row>
            <Col xs={12} className="wizard product">
              <div className="wizard-inner">
                <div
                  className="connecting-line"
                  style={{ width }}
                />
                <Nav className="nav-tabs">
                  {SECTIONS_DATA.get('CUSTOMERS').tools.map(t =>
                    this.renderNavItem(t.name, t.icon)
                  )}
                </Nav>
              </div>
            </Col>
          </Row>
        </Tab.Container>

        <IgPanel style={6}>
          <RenderInstructional
            section={modal}
            show={modal === 'customers'}
          />

          <Switch>
            <Route
              component={BmcBoardWrapper}
              path={`/:locale(en|es)?/customers/:layer(${Object.values(
                STARTUP_SECTIONS
              ).join('|')})?/bmc_boards/:boardId`}
            />

            <Route
              path={`/:locale?/customers/${BusinessSections.IGBUSINESS.name}`}
              component={IgBusinessWrapper}
            />

            <Route
              path={`/:locale?/customers/${BusinessSections.TOC.name}`}
              render={() => (
                <div
                  className="bmc-golden-wrapper"
                  ref={el => (this.tocWrapper = el)}
                />
              )}
            />

            <Route
              path={`/:locale?/customers/${BusinessSections.BMC.name}`}
              exact
              render={() => (
                <Redirect
                  to={`/${intl.locale}/customers/crSection/bmc_boards/${currentBmcId}/step_mode/customer_relationships${modal ? `?modal=${modal}` : ''}`}
                />
              )}
            />

            {!isValidPath && (
              <Redirect
                to={`/${intl.locale}/customers/${BusinessSections.BMC.name}${modal ? `?modal=${modal}` : ''}`}
              />
            )}
          </Switch>
        </IgPanel>
      </div>
    );
  }
}

export default injectIntl(CustomerComponent);



//ORM DE Rails OBject Mapper , active Records

/**
 *Informe Semanal de Avances - ISA*

*Team TOC_Space*

*Miembros y responsabilidad*
Alfredo
Gerard

*1. ¿Qué logró ejecutar?*

1. Primera integracion exitosa de la etapa observacional enla plataforma de ignis gravitas.
2- Introduccion a rails en la plataforma.
3- Estudio de los componentes varios del panel donde se realizo la insercion.
4- Manejo de la arquitectura de carpetas de ignis gravitas.

*2. ¿Qué no logró ejecutar?*
  Dentro de la integracion hubo un problema con la visualizacion del modal de fullscreen dentro de la plataforma, en proceso de solucion.

3. ¿Problemas o Necesidades encontradas?
cortes eléctricos,fallas de Internet, fallas de compilacion al inicio por versiones desactualizadas de algunos paquetes/gemas.

*4. ¿Qué ejecutará en la próxima semana?*

a. Solucion al inconveniente de la modal (apertura del formulario en la plataforma).
b. Continuacion de la integracion con manejo de los datos, states, observadores con Mobx.
c. Inicio de desarrollo de la etapa 2, primer usuario.
d. Correciones de la integracion y de la forma de visualizacion del modal y el formulairo.

*Fin del ISA.*


02/08/2025 EL TOC se ha integrado con exito al componente elaborado por Alfredo
TOC ahora es parte del ecosistema.
gracias a @injectIntl









 <Route
              path={`/:locale?/customers/toc`}
              render={routerProps => (
                <>
                  <BmcGoldenModel
                    {...routerProps}
                    activeStageClick={true}
                    thinkingMode={false}
                    mode={BOARD_TYPES.CURRENT_BMC}
                  />

                  <BmcGoldenModel
                    {...routerProps}
                    activeStageClick={true}
                    thinkingMode={false}
                    mode={BOARD_TYPES.CURRENT_BMC}
                  />


                  {/* <FormToc /> */  /*}
                  /*</>

                  )}
                />









 */



